import { render, staticRenderFns } from "./settingMixin.vue?vue&type=template&id=0ce2a373&scoped=true&"
import script from "./settingMixin.vue?vue&type=script&lang=js&"
export * from "./settingMixin.vue?vue&type=script&lang=js&"
import style0 from "./settingMixin.vue?vue&type=style&index=0&id=0ce2a373&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce2a373",
  null
  
)

export default component.exports